import React from "react";
import { useResponse } from "screens/question/hooks";

import { translateDescription } from "screens/question/themeB/types";
import {
  Container,
  Wrapper,
  RatingButtons,
  RatingButton,
  NumberText,
  ScoreDescription,
  DescriptionText,
  DescriptionLine,
} from "screens/question/themeB/types/score/styled";
import { LineStart, LineRepeat, LineEnd, Emoji, OffsetEmoji } from "./styled";

export const EmojiNpsQuestion = ({ question }) => {
  const { options, RTL, selectOption, selectedOptions } = useResponse(question);

  const firstLastIndices = [0, question.options.length - 1];

  const [detractorEmoji, passiveEmoji, promotorEmoji] = getEmojis(options);

  return (
    <Container>
      <Wrapper>
        {options.map((option, index) => {
          const isSelected = selectedOptions[option.virtual_id];
          const TopLine = scoreLineMap[option.text];

          return (
            <RatingButtons
              $index={index}
              key={option.id}
              $isSelected={isSelected}
            >
              <RatingButton onPress={() => selectOption(option)}>
                <NumberText $isSelected={isSelected}>{option.text}</NumberText>
              </RatingButton>
              <TopLine />
              {option.text === "3" && <Emoji source={detractorEmoji} />}
              {option.text === "7" && <OffsetEmoji source={passiveEmoji} />}
              {option.text === "9" && <OffsetEmoji source={promotorEmoji} />}
              {firstLastIndices.includes(index) &&
                !!option.other_text_placeholder && (
                  <ScoreDescription>
                    <DescriptionLine />
                    <DescriptionText>
                      {translateDescription(option, RTL)}
                    </DescriptionText>
                  </ScoreDescription>
                )}
            </RatingButtons>
          );
        })}
      </Wrapper>
    </Container>
  );
};

const getEmojis = options => {
  const detractor = options.slice(0, 7).find(o => o.image);
  const passive = options.slice(7, 9).find(o => o.image);
  const promotor = options.slice(9).find(o => o.image);

  const sadEmoji = require("assets/images/emoji-sad.png");
  const neutralEmoji = require("assets/images/emoji-neutral.png");
  const happyEmoji = require("assets/images/emoji-happy.png");

  return [
    detractor?.image || sadEmoji,
    passive?.image || neutralEmoji,
    promotor?.image || happyEmoji,
  ];
};

const scoreLineMap = {
  0: LineStart,
  1: LineRepeat,
  2: LineRepeat,
  3: LineRepeat,
  4: LineRepeat,
  5: LineRepeat,
  6: LineEnd,
  7: LineStart,
  8: LineEnd,
  9: LineStart,
  10: LineEnd,
};
